import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getCities({ commit }, data) {
      try {
        const response = await api.get(`/cities`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
